import React from "react";

export default function ProgramAddIcon({
  color = "currentcolor", // or any color of your choice
}) {
  return (
    <svg
      width="1em"
      height="1em"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1920 1920"
    >
      <g id="Layer_1-2">
        <g>
          <polygon
            fill="none"
            strokeWidth={0}
            points="448.7,1506.3 345.2,1506.3 345.2,1802.6 1694.3,1802.6 1694.3,114.2 345.2,115.8 345.2,364.3 
			448.7,364.3 448.7,475.8 345.2,475.8 345.2,706.7 448.7,706.7 448.7,819.8 345.2,819.8 345.2,1050.8 448.7,1050.8 448.7,1162.3 
			345.2,1162.3 345.2,1393.2 448.7,1393.2 		"
          />
          <path
            fill={color}
            strokeWidth={0}
            d="M1807.4,1915.7V1.1L233.7,4.3v360H112.6v113.1h121.1v231H112.6v113.1h121.1v231H112.6v113.1h121.1v231H112.6v113.1h121.1
			v409.4h1573.7V1915.7z M345.2,1162.3h103.5v-113.1H345.2v-231h103.5V705.1H345.2v-231h103.5V361.1H345.2V115.8h1349.1v1686.8
			H345.2v-297.9h103.5v-113.1H345.2v-231L345.2,1162.3z"
          />
        </g>
        <polygon
          fill={color}
          strokeWidth={0}
          points="1417.1,880.4 1109.7,880.4 1109.7,576.1 958.4,576.1 958.4,880.4 649.4,880.4 649.4,1033.3 958.4,1033.3 
		958.4,1343.9 1109.7,1343.9 1109.7,1033.3 1417.1,1033.3 	"
        />
      </g>
    </svg>
  );
}
